/* eslint-disable camelcase */

import { z } from 'zod';
import type { Dayjs } from 'dayjs';

export const authTokenDTOSchema = z.object({
  access_token: z.string(),
  token_type: z.string(),
  expires_in: z.number(),
  scope: z.string(),
  refresh_token: z.string(),
});

export type AuthTokenDTO = z.infer<typeof authTokenDTOSchema>;

export const authTokenSchema = authTokenDTOSchema.merge(
  z.object({
    expires_at: z.custom<Dayjs>(),
  })
);

export type AuthToken = z.infer<typeof authTokenSchema>;

export const loginSchema = z.object({
  username: z.string().min(1, { message: 'Required' }),
  password: z.string().min(1, { message: 'Required' }),
});

export type LoginDTO = z.infer<typeof loginSchema>;

export const sendRemindPwdEmailSchema = z.object({
  email: z.string().email().min(1, { message: 'Required' }),
});

export type SendRemindPwdEmailDTO = z.infer<typeof sendRemindPwdEmailSchema>;
